import React from 'react';
import {level} from "../../../component/level.cmp";
import "../tooltip.css"
import {Grid, GridItem} from "@consta/uikit/Grid";
import {getGraphDayState} from "../../controlRequests/utils/graphDay";


const TooltipGraph = (props: any) => {

    const collName = props.colDef.field.split('.')[0]
    const data = props.api.getDisplayedRowAtIndex(props.rowIndex)?.data?.[collName]
    if (!data || typeof data !== 'object') {
        return null
    }

    const bsiData = Array.isArray(data.bsi) ? data.bsi : []
    const realBsiData = bsiData.filter((item: any) => item?.id || item?.bsi || item?.depth)
    const dayState = getGraphDayState(data)
    const repairInfo = data.repair_info
    const pendingPpk = dayState.ppkPending
    const isManualInput = realBsiData.length === 0
    const isConfirmedPpkPass = Boolean(
        dayState.ppkLimit
        && ['done_planned', 'done', 'done_outside_plan'].includes(dayState.kind)
    )
    return (
        <div className="custom-tooltip">
            {pendingPpk && (
                <div className="custom-tooltip__warning">
                    <b>ППК не подтверждён</b>
                    <div>Глубина ППК: {formatValue(pendingPpk.depth, ' м')}</div>
                    <div>Дата акта: {formatValue(pendingPpk.date)}</div>
                    {pendingPpk.comment && <div>Примечание: {pendingPpk.comment}</div>}
                </div>
            )}

            {isManualInput ?
                // <Grid cols={'1'}>
                //     <GridItem col={"1"}>
                //         <p>
                //             <span><b>{data.level.label}</b></span>
                //         </p>
                //         <p>
                //             <span>Глубина: </span> {data.depth}
                //         </p>
                //     </GridItem>
                // </Grid>
                (data.level?.label ?
                        <>
                            <p>
                                <span><b>РУЧНОЙ ВВОД:</b></span>
                            </p>
                            <p>
                                <span><u>{data.level?.label}</u></span>
                            </p>
                            <p>
                                <span>Глубина: </span> {data.depth}
                            </p>
                            <p>
                                <span><b>{dayState.reason}</b></span>
                            </p>
                            {repairInfo && (
                                <div className="custom-tooltip__repair">
                                    <p><b>Причина ручного ввода: ремонт БСИ</b></p>
                                    <p>{formatValue(repairInfo.comment, '')}</p>
                                    <p>
                                        Период: {formatValue(repairInfo.date_from)} – {formatValue(repairInfo.date_to, '', 'по настоящее время')}
                                    </p>
                                    {repairInfo.fio && <p>Ответственный: {repairInfo.fio}</p>}
                                </div>
                            )}
                        </> :
                        <p>
                            <span><b>{data.comment ? data.comment.label : 'ДАННЫЕ ОТСУТСТВУЮТ!'}</b></span>
                        </p>
                ) :
                <>
                    <Grid cols={2} gap="xs">
                        <GridItem col={1}><b>БСИ:</b></GridItem>
                        <GridItem col={1}><b>РУЧНОЙ ВВОД:</b></GridItem>
                        {realBsiData.map((el: any, index: number) => {
                            const calculatedLevel = level(
                                el.descent_total,
                                Number(el.depth || 0),
                                Number(dayState.fullPassDepth || 900),
                            )
                            const displayLevel = (
                                isConfirmedPpkPass && calculatedLevel.name !== 'Непроход'
                                    ? 'Пройдено по ППК'
                                    : calculatedLevel.name
                            )
                            return <React.Fragment key={index}>

                                <GridItem col={1}>
                                    <p>
                                        <span>
                                            <u>
                                                {displayLevel}
                                            </u>
                                        </span>
                                    </p>
                                    <p>
                                        <span>Глубина: </span> {el.depth.toFixed(1)}
                                    </p>
                                    {isConfirmedPpkPass && (
                                        <p>
                                            <span>Подтвержденный ППК: </span>
                                            {dayState.ppkLimit.depth} м
                                        </p>
                                    )}
                                    <p>
                                        <span>Время спуска: </span> {el.descent_total}
                                    </p>
                                    <p>
                                        <span>Время подьема: </span> {el.lift_total}
                                    </p>
                                </GridItem>
                                < GridItem col={1}>
                                    {index === realBsiData.length - 1 &&
                                        <>
                                            <p>
                                                <span><u>{data.level?.label}</u></span>
                                            </p>
                                            <p>
                                                <span>Глубина: </span> {data.depth}
                                            </p>
                                        </>
                                    }
                                </GridItem>
                            </React.Fragment>
                        })}

                    </Grid>
                </>
            }
        </div>
    );
};

function formatValue(value: any, suffix = '', emptyValue = '—') {
    return value === null || value === undefined || value === ''
        ? emptyValue
        : `${value}${suffix}`
}

export default TooltipGraph;
